<template>
          <v-dialog v-model="dialog" width="100%"  style="margin: 100px !important;" persistent class="custom-dialog">
        <v-card>
            <v-card-title>
                <span class="text-h5">
                    Criar Romaneio
                </span>
            </v-card-title>

            <div style="padding: 20px">
                
                <v-row no-gutters style="gap: 15px;">
                    <v-text-field 
                        v-model="romaneio.localCarreg"
                        class="pt-5 pb-5"
                        type="text" 
                        label="Local de Carregamento"
                        chips
                        clearable
                        hide-details
                        outlined
                    ></v-text-field>

                    <v-text-field 
                    v-model="romaneio.respCarreg"
                    class="pt-5 pb-5"
                    type="text"
                    label="Responsável pelo Carregamento"
                    clearable
                    hide-details
                    outlined
                    />

                    <v-text-field 
                        v-model="romaneio.placaVeiculo"
                        class="pt-5 pb-5"
                        type="text"
                        label="Placa do Veículo"
                        clearable
                        hide-details
                        outlined
                    />

                    <v-text-field 
                        v-model="romaneio.placaCarreta"
                        class="pt-5 pb-5"
                        type="text"
                        label="Placa da Carreta"
                        clearable
                        hide-details
                        outlined
                    />

                </v-row>

                <v-row no-gutters style="gap: 15px;">

                    <v-text-field 
                        v-model="romaneio.motNome"
                        class="pt-5 pb-5"
                        type="text"
                        label="Nome do Motorista"
                        clearable
                        hide-details
                        outlined

                    />

                    <v-text-field 
                        v-model="romaneio.motCpf"
                        class="pt-5 pb-5"
                        type="text"
                        label="CPF do Motorista"
                        clearable
                        hide-details
                        outlined
                        v-mask="'###.###.###-##'"
                    />

                    <v-text-field 
                        v-model="romaneio.motRG"
                        class="pt-5 pb-5"
                        type="text"
                        label="RG do Motorista"
                        clearable
                        hide-details
                        outlined
                        v-mask="'##.###.###-#'"
                    />

                    <v-text-field 
                        v-model="romaneio.motCelular"
                        v-mask="'(##) #####-####'"
                        class="pt-5 pb-5"
                        type="text"
                        label="Celular do Motorista"
                        clearable
                        hide-details
                        outlined
                    />

                </v-row>

                <v-row no-gutters style="gap: 15px;">

                    <v-text-field 
                        v-model="romaneio.respReceb"
                        class="pt-5 pb-5"
                        type="text"
                        label="Responsável pelo Recebimento"
                        clearable
                        hide-details
                        outlined
                    />

                    <v-autocomplete 
                        v-model="romaneio.transportadora"
                        class="pt-5 pb-5"
                        type="text"
                        label="Transportadora"
                        clearable
                        hide-details
                        outlined
                        :items="fornecedores"
                        :item-text="'nomeFantasia'"
                        :item-value="'id'"
                    ></v-autocomplete>

                    <v-autocomplete 
                        v-model="romaneio.fornecedor"
                        class="pt-5 pb-5"
                        type="text"
                        label="Fornecedor"
                        clearable
                        hide-details
                        outlined
                        :items="fornecedores"
                        :item-text="'nomeFantasia'"
                        :item-value="'id'"
                    ></v-autocomplete>

                    <vuetify-money
                        v-model="romaneio.vlrTotal"
                        class="pt-5 pb-5"
                        type="number"
                        label="Valor Total"
                        clearable
                        hide-details
                        outlined
                    />


                </v-row>

                <v-row no-gutters style="gap: 15px;">

                    <!-- BUGFIX: era v-combobox, que permite digitar e confirmar QUALQUER texto livre
                         (inclusive um valor fora do enum aceito pelo backend/NF-e) — foi assim que um
                         Romaneio ficou salvo com "TCR" digitado manualmente antes de existir na lista,
                         quebrando a Pré-Visualização. v-autocomplete usa a digitação só para filtrar
                         a lista; o valor só é definido de fato ao selecionar um item existente. -->
                    <v-autocomplete
                        v-model="romaneio.tipoFrete"
                        :items="tipoFreteOptions"
                        class="pt-5 pb-5"
                        type="text"
                        label="Tipo de Frete"
                        clearable
                        hide-details
                        outlined
                    />

                    <v-text-field 
                        v-model="romaneio.quantidade"
                        class="pt-5 pb-5"
                        type="number"
                        label="Quantidade"
                        clearable
                        hide-details
                        outlined
                    />

                    <v-text-field 
                        v-model="romaneio.especie"
                        class="pt-5 pb-5"
                        type="text"
                        label="Espécie"
                        clearable
                        hide-details
                        outlined
                    />

                    <v-text-field 
                        v-model="romaneio.marca"
                        class="pt-5 pb-5"
                        type="text"
                        label="Marca"
                        clearable
                        hide-details
                        outlined
                    />
                </v-row>

                <v-row no-gutters style="gap: 15px;">

                    <v-text-field 
                        v-model="romaneio.numeracao"
                        class="pt-5 pb-5"
                        type="text"
                        label="Numeração"
                        clearable
                        hide-details
                        outlined
                    />

                    <v-text-field 
                        v-model="romaneio.pesoBruto"
                        class="pt-5 pb-5"
                        type="number"
                        label="Peso Bruto"
                        clearable
                        hide-details
                        outlined
                    />

                    <v-text-field 
                        v-model="romaneio.pesoLiquido"
                        class="pt-5 pb-5"
                        type="number"
                        label="Peso Líquido"
                        clearable
                        hide-details
                        outlined
                    />
                </v-row>

                <v-row no-gutters style="gap: 15px;">
                    <v-textarea 
                        v-model="romaneio.multaObs"
                        class="pt-5 pb-5"
                        type="text"
                        label="Observações/Multa"
                        clearable
                        hide-details
                        outlined
                    />
                </v-row>
                
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>Código</th>
                            <th>Status</th>
                            <th>Desceção</th>
                            <th>Data</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in itemsSelected" :key="index">
                            <td class="pa-5">
                                {{  item.codigo }}
                            </td>
                            <td>
                                {{ item.status }}
                            </td>
                            <td class="pa-5">
                                {{ item.descricao }}
                            </td>
                            <td class="pa-5">
                                {{ item.dataCriacao ? new Date(item.dataCriacao).toLocaleDateString() : "Não informado" }}
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>


            </div>
            
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="$emit('close')">
                    Cancelar
                </v-btn>
                
                <v-btn color="blue darken-1" text @click="saveRomaneio">
                    Confirmar
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>

import {VMoney} from 'v-money'
import Vue from 'vue';

export default {
    name: 'CreateRomaneioView',
    props: ['open', 'itemsSelected'],
    directives: { money: VMoney }, 
    data() {
        return {
            dialog: false,
            money: {
                locale: "pt-br",
                length: 11,
                precision: this.precision || 2,
                masked: false
            },
            // BUGFIX: lista estava com só 11 opções e com um texto diferente do enum que o backend
            // (schema do Romaneio) realmente aceita — faltavam TCR e SOT (por isso alguém digitou
            // "TCR" manualmente no combobox antigo, e isso quebrava a geração da Nota por não ser
            // reconhecido em mapTipoFreteToModalidadeFrete). Lista abaixo copiada literalmente do
            // enum "tipoFrete" do schema do Romaneio, para o valor salvo aqui bater exatamente com o
            // que o backend espera.
            tipoFreteOptions: [
                "CIF Custo, Seguro e Frete - o vendedor paga o frete e o seguro até o porto de destino, mas o risco é transferido no embarque.",
                "FOB Livre a Bordo - o vendedor entrega a mercadoria no porto de embarque; o comprador assume os custos e riscos do transporte.",
                "CFR Custo e Frete - o vendedor paga o frete até o destino, mas não o seguro.",
                "EXW Na Origem - o vendedor apenas disponibiliza a mercadoria em sua fábrica/depósito; o comprador assume todos os custos e riscos.",
                "FCA Livre no Transportador - o vendedor entrega a mercadoria a um transportador designado pelo comprador.",
                "FAS Livre ao Lado do Navio - o vendedor entrega a mercadoria ao lado do navio no porto de embarque.",
                "CPT Transporte Pago Até - o vendedor paga o frete até o destino combinado, sem seguro.",
                "CIP Transporte e Seguro Pagos Até - o vendedor paga o frete e o seguro até o destino combinado.",
                "DAP Entregue no Local - o vendedor entrega a mercadoria no local do comprador, mas sem pagar o desembaraço aduaneiro.",
                "DPU Entregue no Local Descarregado - o vendedor entrega a mercadoria no local combinado, já com a descarga realizada.",
                "DDP Entregue com Direitos Pagos - o vendedor entrega a mercadoria no local do comprador, com impostos e desembaraço aduaneiro já pagos.",
                "TCR Transporte Próprio - o transporte é realizado pelo próprio remetente.",
                "SOT Sem Ocorrência de Transporte - não há ocorrência de transporte."
            ],
            fornecedores: [],
            romaneio: {
                localCarreg: '',
                respCarreg: '',
                placaVeiculo: '',
                placaCarreta: '',
                motNome: '',
                motCpf: '',
                motRG: '',
                motCelular: '',
                respReceb: '',
                vlrTotal: 0,
                transportadora: '',
                fornecedor: '',
                tipoFrete: '',
                quantidade: 0,
                especie:'',
                marca: '',
                numeracao: '',
                pesoBruto: '',
                pesoLiquido: '',
                multaObs: '',
            }
        }
    },
    methods: {
        saveRomaneio() {
            this.$emit('save', this.romaneio);
        },

        async getFornecedores(){
            const response = await Vue.prototype.$http.get('/Entity/Fornecedor', {
                params: {
                    page: 1,
                    limit: 9999
                }
            })
            this.fornecedores = response.data.data.data
        }
    },

    watch: {
        open(value){
            this.dialog = value
        }
    },

    async created() {
        await this.getFornecedores();
    }


}
</script>

<style>

</style>